import React from 'react';
import Cta from '../components/Cta';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Services from '../components/Services';
import ClientTestimonials from '../components/ClientTestimonials';
import { Helmet } from "react-helmet";

const Home = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Home | Al Ghaith Properties</title>
                <meta name="description" content="Al Ghaith Properties offers premium villas, apartments, and commercial spaces for rent and sale in Dubai. Discover your next home or investment property today." />
                <link rel="canonical" href="https://www.al-ghaith.ae" />
            </Helmet>
            <Hero />
            <Intro />
            <Services />
            {/* <Portfolio /> */}
            <Cta/>
            <ClientTestimonials />
        </>
    )
}

export default Home;

